import React, { useState } from 'react'
import PostItem from '../postitem/PostItem'
import './Post.css'

function Post({dummy}) {
    const [comment, setComment] = useState("");

    const posts = [];
    const posts1 = {
        upvote: 130,
        image: "https://www.adorama.com/alc/wp-content/uploads/2018/11/landscape-photography-tips-yosemite-valley-feature-825x465.jpg",
        title: "Question about new wallet",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: 11
    }
    const posts2 = {
        upvote: 105,
        image: "https://icdn.isrgrajan.com/in/2022/11/Virat-Kohli.jpg",
        title: "Virat Kohli always plays amazingly.",
        user: "theindependentonline",
        subreddit: "Sports",
        comment_count: " 30"
    }
    const posts3 = {
        upvote: 95,
        image: "https://hips.hearstapps.com/clv.h-cdn.co/assets/18/02/1515470256-levi-guzman-268866.jpg",
        title: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda, sint.",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "15"
    }
    const posts4 = {
        upvote: 45,
        image: "https://img1.hscicdn.com/image/upload/f_auto,t_ds_w_1200,q_50/lsci/db/PICTURES/CMS/357400/357408.jpg",
        title: "IPL 2022: MS Dhoni hands over CSK captaincy to Ravindra Jadeja",
        user: "theindependentonline",
        subreddit: "Sports",
        comment_count: "38"
    }
    const posts5 = {
        upvote: 44,
        image: "https://external-preview.redd.it/Px6sIQjon2ZS1XnxzNq8IuTnyI2ou6u7cA3xR4j3kyA.jpg?width=640&crop=smart&auto=webp&v=enabled&s=01eaad3c31b81b92288c9b9a77cf1bf2bd7c04a0",
        title: "Inspiring AI generated art in your new tab!",
        user: "theindependentonline",
        subreddit: "Trending",
        comment_count: "22"
    }
    const posts6 = {
        upvote: 15,
        image: "https://preview.redd.it/zsjbkytwmgva1.jpg?width=640&crop=smart&auto=webp&v=enabled&s=386fd92dbf1a135c440e25576e31c06b751df3de",
        title: "Scarcity of youth actors between the age group 25-30.",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "34"
    }
    const posts7 = {
        upvote: 15,
        image: "https://preview.redd.it/xx7o8qvx7dva1.jpg?width=640&crop=smart&auto=webp&v=enabled&s=7e4ff838961a0f23b6524781561bc6cc0201cc9d",
        title: "Crypto slums (Rainy) by artist Mikael Mellbris.",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "15"
    }
    const posts8 = {
        upvote: 15,
        image: "https://preview.redd.it/72xnxg5habsa1.jpg?width=640&crop=smart&auto=webp&v=enabled&s=44bcd75265c0399ec5cfa32eba364112647b5be0",
        title: "THIS DAY... AN ENTIRE DECADE AGO, THE PEAK FICTION WAS FIRST WITNESSED ON GLOBAL TELEVISION.",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "15"
    }
    const posts9 = {
        upvote: 15,
        image: "https://external-preview.redd.it/qDdEEtYCf2ykhBCeaZFHmr1e3F2czTKEhIwDGDmp5PU.jpg?width=640&crop=smart&auto=webp&v=enabled&s=7bdf07e1bdf05f17e1aa0429d43a18f35b9094e5",
        title: "Streamline Your Voice-Over Business with Nimble CRM.",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "15"
    }
    const posts10 = {
        upvote: 15,
        image: "https://preview.redd.it/11586tdo8ula1.jpg?width=640&crop=smart&auto=webp&v=enabled&s=ff6dcc8e77c1e0c0646434e14ebcb88d3899feb8",
        title: "Finally time to change the rear tire.",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "15"
    }
    const posts11 = {
        upvote: 15,
        image: "https://preview.redd.it/ebr5gzg8hfia1.jpg?width=640&crop=smart&auto=webp&v=enabled&s=5d31c3f7e480a882949186ed55196e0c80c74114",
        title: "Hecate’s Art Journals Chief! Our scooters are only a means of transport;",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "15"
    }
    const posts12 = {
        upvote: 15,
        image: "https://preview.redd.it/g9zn1ktdwfva1.png?width=640&crop=smart&auto=webp&v=enabled&s=0a5d441881ce1219fcab3bb15c43d74616fdfd38",
        title: "bklol for a reason",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "15"
    }
    const posts13 = {
        upvote: 15,
        image: "https://external-preview.redd.it/LA_psPBk4F3KJTwjEZo1xVlHLtJ0hTiqWDTN_WNKopY.jpg?width=640&crop=smart&auto=webp&v=enabled&s=612421fa5e72cd7ecc4a40ac8a9f29023d436e0f",
        title: "Hey guys, after four years of development, we are happy to announce the release of the final version of Crash Test Oliver.",
        user: "theindependentonline",
        subreddit: "politics",
        comment_count: "15"
    }
    if(dummy===1){

    posts.push(posts1, posts2, posts3, posts4, posts5, posts6, posts7, posts8, posts9, posts10, posts11, posts12, posts13 );
    }
    else if(dummy===2){
        posts.push(posts1,posts5,posts6,posts7,posts11,posts1,posts8);
    }
    else if(dummy===3){
        posts.push(posts7, posts8, posts9, posts10, posts11, posts12, posts13);
    }
    else if(dummy===4){
        posts.push(posts2, posts3, posts4, posts5, posts6, posts7, posts8, posts9,);
    }
    else{
        posts.push(posts3,posts9,posts10,posts11,posts12,posts13);
    }
    localStorage.setItem("posts", JSON.stringify(posts));

    const postComment = () => {
        if (comment) {
            const obj = {
                upvote: 0,
                image: "https://www.adorama.com/alc/wp-content/uploads/2018/11/landscape-photography-tips-yosemite-valley-feature-825x465.jpg",
                title: comment,
                user: "theindependentonline",
                subreddit: "general",
                comment_count: 0
            }
            const newpost = JSON.parse(localStorage.getItem("post") || "[]");
            newpost.push(obj);
            localStorage.setItem("post", JSON.stringify(newpost));
            setComment("");
        }
    }

    return (
        <div className='posts'>
            <div className="inputsection">
                <input className='input' placeholder='Create Post' value={comment} onChange={e => setComment(e.target.value)} />
                <button className='btn' onClick={postComment} >Post</button>
            </div>
            {console.log(comment)}
            {/* {posts.map(post => (
                <PostItem post={post} />
               
            ))} */}
            {
                JSON.parse(localStorage.getItem("posts")).map((e, index) => {
                    return (
                        <PostItem post={e} />
                    )
                })
            }
             { JSON.parse(localStorage.getItem("post")) &&
                JSON.parse(localStorage.getItem("post")).map((e, index) => {
                    return (
                        <PostItem post={e} key={index}/>
                    )
                })
            }
        </div>
    )
}

export default Post